module.exports = __webpack_public_path__ + "static/Makwe-f38b97435d965e2439cf0130ae8aa228.png";